import isElement from './isElement';
export default function isHTMLElement(object) {
  try {
    return object instanceof HTMLElement;
  } catch (error) {
    // Use duck typing for browsers not supporting W3 DOM2 API
    return isElement(object) && 'offsetWidth' in object;
  }
}
//# sourceMappingURL=isHTMLElement.js.map